import BudgetTableRowMobile from './BudgetTableRowMobile';
import { IBudgetItem } from '../BudgetItemsTable';

interface IBudgetItemsTableMobileProps {
  items: IBudgetItem[];
  proposalItems?: IBudgetItem[];
  isExternalService?: boolean;
  isEditMode?: boolean;
  onItemChange?: (index: number, field: keyof IBudgetItem, value: string | number) => void;
  onRemoveItem?: (index: number) => void;
}

const BudgetItemsTableMobile = (props: IBudgetItemsTableMobileProps) => {
  return (
    <div className="mb-3 w-full">
      <div className="flex flex-col gap-3">
        {props.items.map((item, index) => {
          const originalItem = 
            props.proposalItems?.[index]?.ref === item.ref
              ? props.proposalItems[index]
              : props.proposalItems?.find((proposalItem, proposalIndex) => 
                  proposalItem.ref === item.ref && proposalIndex === index
                );
          
          return (
            <BudgetTableRowMobile
              key={`item-${item.ref}-${index}`}
              item={item}
              originalItem={originalItem}
              index={index}
              isExternalService={props.isExternalService}
              isEditMode={props.isEditMode}
              onItemChange={props.onItemChange}
              onRemoveItem={props.onRemoveItem}
            />
          );
        })}
      </div>
    </div>
  );
};

export default BudgetItemsTableMobile;
